<template>

    <v-modal title="Subscribe to Plan">
        <template #body>
            <v-alert :message="error" />
            <v-form-group dir="ver">
                <v-list>
                    <v-list-item>
                        <div>
                            <span>{{ amount / 100 | currency }} / {{ plan.interval }}</span><br>
                            <span class="small">{{ users | numeral('0,0') }} customers</span>
                        </div>
                    </v-list-item>
                </v-list>
            </v-form-group>
            <v-form-group dir="ver">
                <v-input-card @error="error = $event" />
            </v-form-group>
            <v-form-group dir="ver">
                <v-input-coupon @input="params.promotion_code = $event" />
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="createSubscription">Subscribe</v-button>
        </template>
    </v-modal>

</template>

<script>

import CompanyApi from '@api/CompanyApi';

export default {

    props: {
        plan: {
            type: Object,
            required: true,
        },
        amount: {
            type: Number,
            required: true,
        },
        quantity: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {
                plan: this.plan.id,
                quantity: this.quantity,
            },
        }
    },

    computed: {

        company() {
            return this.$store.getters.company;
        },

        users() {
            if (this.plan.billing_scheme === 'per_unit') {
                return this.plan.transform_usage.divide_by;
            }
            return this.quantity;
        },

    },

    methods: {

        createSubscription() {
            this.loading = true;
            let stripe = this.$store.getters['stripe/stripe'];
            let card = this.$store.getters['stripe/card'];
            stripe.createToken(card).then((result) => {
                if (!result.error) {
                    this.params.stripe_token = result.token.id;
                    CompanyApi.createSubscription(this.company.id, this.params)
                        .then((response) => {
                            this.loading = false;
                            this.$emit('changed');
                            this.$store.commit('setAlertSuccess', this.$t('message.subscribed'));
                            this.$store.commit('showModal', false);
                        }, (error) => {
                            this.loading = false;
                            this.error = error.response.data.message;
                        });
                } else {
                    this.loading = false;
                    this.error = result.error.message;
                }
            });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
